import { render } from "./ListClaims.vue?vue&type=template&id=a198a136&ts=true"
import script from "./ListClaims.vue?vue&type=script&lang=ts"
export * from "./ListClaims.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__